import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=6b746a6a&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=6b746a6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b746a6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b746a6a')) {
      api.createRecord('6b746a6a', component.options)
    } else {
      api.reload('6b746a6a', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=6b746a6a&scoped=true&", function () {
      api.rerender('6b746a6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2r1wU4hEhwa13/JS/comp/Voucher.vue"
export default component.exports